"use strict";
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var MrsMorphEstuaries_exports = {};
__export(MrsMorphEstuaries_exports, {
  MrsMorphEstuaries: () => MrsMorphEstuaries,
  MrsMorphEstuariesPro: () => MrsMorphEstuariesPro
});
module.exports = __toCommonJS(MrsMorphEstuaries_exports);
var import_topo_map = require("@cartographerio/topo-map");
var import_core = require("../../core/index.js");
var import_helpers = require("./helpers.js");
function morphEstuariesMap(mapId, title) {
  return (0, import_core.mapSchemaWithDefaults)({
    mapId,
    title,
    layers: [
      (0, import_topo_map.pointLayer)({
        layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
        title,
        source: (0, import_core.cartographerSourceWithDefaults)({
          layerId: (0, import_topo_map.unsafeMapLayerId)(mapId),
          attribution: []
        }),
        defaultAttribute: "estuaryName",
        defaultZOrder: "timestamp",
        attributes: [
          (0, import_topo_map.attributeGroup)({
            label: "General",
            attributes: [
              (0, import_topo_map.stringAttr)({
                attributeId: "estuaryName",
                label: "Estuary",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "subreachName",
                label: "Subreach",
                buckets: "auto"
              }),
              import_helpers.moduleNumberAttr,
              (0, import_topo_map.stringAttr)({
                attributeId: "projectName",
                label: "Project Name",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "projectCode",
                label: "Project Code",
                buckets: "auto"
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "wfdWaterbodyId",
                label: "WFD Waterbody ID",
                buckets: "auto"
              }),
              import_helpers.surveyTypeAttr,
              (0, import_topo_map.teamAttr)("teamId", "Team"),
              (0, import_topo_map.surveyAttr)("surveyId", "Survey"),
              (0, import_topo_map.attachmentAttr)("photographs", "Photographs"),
              (0, import_topo_map.timestampAttr)({
                attributeId: "timestamp",
                label: "Date/Time",
                buckets: "auto"
              })
            ]
          }),
          (0, import_topo_map.attributeGroup)({
            label: "Indices (WIP)",
            attributes: [
              (0, import_topo_map.thresholdAttr)({
                attributeId: "E1",
                label: "E1: Number of Present/Extensive (Exposed) Sediment Material Types",
                buckets: [
                  (0, import_topo_map.thresholdBucket)(0, import_topo_map.marker.quality(0 / 6), "<2"),
                  (0, import_topo_map.thresholdBucket)(2, import_topo_map.marker.quality(1 / 6), "2 to <3"),
                  (0, import_topo_map.thresholdBucket)(3, import_topo_map.marker.quality(2 / 6), "3 to <4"),
                  (0, import_topo_map.thresholdBucket)(4, import_topo_map.marker.quality(3 / 6), "4 to <5"),
                  (0, import_topo_map.thresholdBucket)(5, import_topo_map.marker.quality(4 / 6), "5 to <6"),
                  (0, import_topo_map.thresholdBucket)(6, import_topo_map.marker.quality(5 / 6), "6 to <7"),
                  (0, import_topo_map.thresholdBucket)(7, import_topo_map.marker.quality(6 / 6), "7+")
                ]
              }),
              (0, import_topo_map.stringAttr)({
                attributeId: "E2",
                label: "E2: Coarsest Present/Extensive Mineral Sediment Material Type",
                buckets: [
                  (0, import_topo_map.lookupBucket)("Bedrock", import_topo_map.marker.hue(7 / 8 * 360), "Bedrock"),
                  (0, import_topo_map.lookupBucket)("Boulder", import_topo_map.marker.hue(6 / 8 * 360), "Boulder"),
                  (0, import_topo_map.lookupBucket)("Cobble", import_topo_map.marker.hue(5 / 8 * 360), "Cobble"),
                  (0, import_topo_map.lookupBucket)("GravelPebble", import_topo_map.marker.hue(4 / 8 * 360), "Gravel-Pebble"),
                  (0, import_topo_map.lookupBucket)("ShellyMaterial", import_topo_map.marker.hue(3 / 8 * 360), "Shelly Material"),
                  (0, import_topo_map.lookupBucket)("Sand", import_topo_map.marker.hue(2 / 8 * 360), "Sand"),
                  (0, import_topo_map.lookupBucket)("FineSediments", import_topo_map.marker.hue(1 / 8 * 360), "Fine Sediments"),
                  (0, import_topo_map.lookupBucket)("FluidMud", import_topo_map.marker.hue(0 / 8 * 360), "Fluid Mud")
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E3",
                label: "E3: Estuary Margin Profile",
                buckets: [
                  (0, import_topo_map.rangeBucket)(66, null, import_topo_map.marker.quality(7 / 7)),
                  (0, import_topo_map.rangeBucket)(40, 66, import_topo_map.marker.quality(6 / 7)),
                  (0, import_topo_map.rangeBucket)(18, 40, import_topo_map.marker.quality(5 / 7)),
                  (0, import_topo_map.rangeBucket)(1, 18, import_topo_map.marker.quality(4 / 7)),
                  (0, import_topo_map.rangeBucket)(-20, 1, import_topo_map.marker.quality(3 / 7)),
                  (0, import_topo_map.rangeBucket)(-100, -20, import_topo_map.marker.quality(2 / 7)),
                  (0, import_topo_map.rangeBucket)(-250, -100, import_topo_map.marker.quality(1 / 7)),
                  (0, import_topo_map.rangeBucket)(null, -250, import_topo_map.marker.quality(0 / 7))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E4",
                label: "E4: Marginal Habitat Richness for Biota",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, 3, import_topo_map.marker.quality(5 / 10)),
                  (0, import_topo_map.rangeBucket)(3, 6, import_topo_map.marker.quality(6 / 10)),
                  (0, import_topo_map.rangeBucket)(6, 9, import_topo_map.marker.quality(7 / 10)),
                  (0, import_topo_map.rangeBucket)(9, 12, import_topo_map.marker.quality(8 / 10)),
                  (0, import_topo_map.rangeBucket)(12, 15, import_topo_map.marker.quality(9 / 10)),
                  (0, import_topo_map.rangeBucket)(15, null, import_topo_map.marker.quality(10 / 10))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E5",
                label: "E5: Subtidal & Unvegetated Intertidal Physical Habitat Complexity",
                buckets: [
                  (0, import_topo_map.rangeBucket)(0, 1, import_topo_map.marker.quality(0 / 6)),
                  (0, import_topo_map.rangeBucket)(1, 2, import_topo_map.marker.quality(1 / 6)),
                  (0, import_topo_map.rangeBucket)(2, 3, import_topo_map.marker.quality(2 / 6)),
                  (0, import_topo_map.rangeBucket)(3, 4, import_topo_map.marker.quality(3 / 6)),
                  (0, import_topo_map.rangeBucket)(4, 5, import_topo_map.marker.quality(4 / 6)),
                  (0, import_topo_map.rangeBucket)(5, 6, import_topo_map.marker.quality(5 / 6)),
                  (0, import_topo_map.rangeBucket)(6, null, import_topo_map.marker.quality(6 / 6))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E6",
                label: "E6: Vegetated Intertidal Natural Features Richness (Physical Habitat Complexity)",
                buckets: [
                  (0, import_topo_map.rangeBucket)(0, 2, import_topo_map.marker.quality(5 / 10)),
                  (0, import_topo_map.rangeBucket)(2, 4, import_topo_map.marker.quality(6 / 10)),
                  (0, import_topo_map.rangeBucket)(4, 6, import_topo_map.marker.quality(7 / 10)),
                  (0, import_topo_map.rangeBucket)(6, 8, import_topo_map.marker.quality(8 / 10)),
                  (0, import_topo_map.rangeBucket)(8, 10, import_topo_map.marker.quality(9 / 10)),
                  (0, import_topo_map.rangeBucket)(10, null, import_topo_map.marker.quality(10 / 10))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E7",
                label: "E7: Supratidal & Riparian Physical Habitat Complexity",
                buckets: [
                  (0, import_topo_map.rangeBucket)(0, 2, import_topo_map.marker.quality(5 / 10)),
                  (0, import_topo_map.rangeBucket)(2, 4, import_topo_map.marker.quality(6 / 10)),
                  (0, import_topo_map.rangeBucket)(4, 6, import_topo_map.marker.quality(7 / 10)),
                  (0, import_topo_map.rangeBucket)(6, 8, import_topo_map.marker.quality(8 / 10)),
                  (0, import_topo_map.rangeBucket)(8, 10, import_topo_map.marker.quality(9 / 10)),
                  (0, import_topo_map.rangeBucket)(10, null, import_topo_map.marker.quality(10 / 10))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E8",
                label: "E8: Degree of Human Pressure Imposed by Supratidal Land Cover",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, -20, import_topo_map.marker.quality(0 / 7)),
                  (0, import_topo_map.rangeBucket)(-20, -15, import_topo_map.marker.quality(1 / 7)),
                  (0, import_topo_map.rangeBucket)(-15, -10, import_topo_map.marker.quality(2 / 7)),
                  (0, import_topo_map.rangeBucket)(-10, -8, import_topo_map.marker.quality(3 / 7)),
                  (0, import_topo_map.rangeBucket)(-8, -6, import_topo_map.marker.quality(4 / 7)),
                  (0, import_topo_map.rangeBucket)(-6, -4, import_topo_map.marker.quality(5 / 7)),
                  (0, import_topo_map.rangeBucket)(-4, -2, import_topo_map.marker.quality(6 / 7)),
                  (0, import_topo_map.rangeBucket)(-2, 0, import_topo_map.marker.quality(7 / 7))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E9",
                label: "E9: Channel Reinforcement",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, -10, import_topo_map.marker.quality(0 / 10)),
                  (0, import_topo_map.rangeBucket)(-10, -8, import_topo_map.marker.quality(2 / 10)),
                  (0, import_topo_map.rangeBucket)(-8, -6, import_topo_map.marker.quality(4 / 10)),
                  (0, import_topo_map.rangeBucket)(-6, -4, import_topo_map.marker.quality(6 / 10)),
                  (0, import_topo_map.rangeBucket)(-4, -2, import_topo_map.marker.quality(8 / 10)),
                  (0, import_topo_map.rangeBucket)(-2, 0, import_topo_map.marker.quality(10 / 10))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E10",
                label: "E10: Vegetated Intertidal Signs of Erosion",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, -10, import_topo_map.marker.quality(0 / 10)),
                  (0, import_topo_map.rangeBucket)(-10, -8, import_topo_map.marker.quality(2 / 10)),
                  (0, import_topo_map.rangeBucket)(-8, -6, import_topo_map.marker.quality(4 / 10)),
                  (0, import_topo_map.rangeBucket)(-6, -4, import_topo_map.marker.quality(6 / 10)),
                  (0, import_topo_map.rangeBucket)(-4, -2, import_topo_map.marker.quality(8 / 10)),
                  (0, import_topo_map.rangeBucket)(-2, 0, import_topo_map.marker.quality(10 / 10))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E11",
                label: "E11: Terrestrial Non-Native Invasive Plant Extent",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, -10, import_topo_map.marker.quality(0 / 10)),
                  (0, import_topo_map.rangeBucket)(-10, -8, import_topo_map.marker.quality(2 / 10)),
                  (0, import_topo_map.rangeBucket)(-8, -6, import_topo_map.marker.quality(4 / 10)),
                  (0, import_topo_map.rangeBucket)(-6, -4, import_topo_map.marker.quality(6 / 10)),
                  (0, import_topo_map.rangeBucket)(-4, -2, import_topo_map.marker.quality(8 / 10)),
                  (0, import_topo_map.rangeBucket)(-2, 0, import_topo_map.marker.quality(10 / 10))
                ]
              }),
              (0, import_topo_map.numberAttr)({
                attributeId: "E12",
                label: "E12: Litter",
                buckets: [
                  (0, import_topo_map.rangeBucket)(null, -30, import_topo_map.marker.quality(0 / 9)),
                  (0, import_topo_map.rangeBucket)(-30, -25, import_topo_map.marker.quality(1 / 9)),
                  (0, import_topo_map.rangeBucket)(-25, -20, import_topo_map.marker.quality(2 / 9)),
                  (0, import_topo_map.rangeBucket)(-20, -15, import_topo_map.marker.quality(3 / 9)),
                  (0, import_topo_map.rangeBucket)(-15, -10, import_topo_map.marker.quality(4 / 9)),
                  (0, import_topo_map.rangeBucket)(-10, -8, import_topo_map.marker.quality(5 / 9)),
                  (0, import_topo_map.rangeBucket)(-8, -6, import_topo_map.marker.quality(6 / 9)),
                  (0, import_topo_map.rangeBucket)(-6, -4, import_topo_map.marker.quality(7 / 9)),
                  (0, import_topo_map.rangeBucket)(-4, -2, import_topo_map.marker.quality(8 / 9)),
                  (0, import_topo_map.rangeBucket)(-2, 0, import_topo_map.marker.quality(9 / 9))
                ]
              })
            ]
          })
        ]
      })
    ]
  });
}
const MrsMorphEstuaries = morphEstuariesMap((0, import_topo_map.unsafeMapId)("mrsMorphEstuaries"), "MoRPh Estuaries");
const MrsMorphEstuariesPro = morphEstuariesMap((0, import_topo_map.unsafeMapId)("mrsMorphEstuariesPro"), "MoRPh Estuaries");
// Annotate the CommonJS export names for ESM import in node:
0 && (module.exports = {
  MrsMorphEstuaries,
  MrsMorphEstuariesPro
});
//# sourceMappingURL=MrsMorphEstuaries.js.map
